// SCSS entry file
import '../_scss/main.scss';

import './components/root';

// Off Canvas menu
(function($) {
	'use strict';

	$(function() {
		var menu = {
			isOpen: false,

			toggle: function() {
				if (this.isOpen) {
					this.close();
				} else {
					this.open();
				}
			},

			open: function() {
				$('body').addClass('has-off-canvas');

				$('.js-off-canvas-toggle').addClass('is-on');

				this.isOpen = true;
			},

			close: function() {
				$('body').removeClass('has-off-canvas');

				$('.js-off-canvas-toggle').removeClass('is-on');

				this.isOpen = false;
			},
		};

		$(document).on('click touchend', function(e) {
			if ($('body').hasClass('has-off-canvas')) {
				e.stopImmediatePropagation();

				// Do not trigger on clicks on the menu
				if (!$(e.target).closest('.off-canvas__menu').length) {
					menu.close();
				}
			}
		});

		$('.js-off-canvas-toggle').on('click', function(e) {
			e.stopPropagation(); // Sorry world, I shouldn't be doing that.

			var data = $(this).data();

			// Reveal the correct menu
			if (!menu.isOpen && 'offCanvasTarget' in data) {
				$('.off-canvas__menu').hide();
				$(data.offCanvasTarget).show();
			}

			menu.toggle();
		});
	});
})(jQuery);

// Sticky menu
window.onload = function() {
	fixMenu();
};

window.onscroll = function() {
	fixMenu();
};

const menu = document.querySelector('.o-sticky');
const sticky = menu.offsetTop;
const logo = document.querySelector('.header-menu__logo-link');
const hero = document.querySelector('.hero');
const logoText = document.querySelector('.gi-logo__text');

function fixMenu() {
	if (window.pageYOffset > sticky) {
		menu.classList.add('is-fixed');
		hero.classList.add('hero-top');
	} else {
		menu.classList.remove('is-fixed');
		hero.classList.remove('hero-top');
	}

	if (window.pageYOffset > sticky - 15) {
		logo.classList.add('header-menu__logo-link--schrink');
		menu.classList.add('add-border');
		logoText.classList.add('hide-text');
	} else {
		logo.classList.remove('header-menu__logo-link--schrink');
		menu.classList.remove('add-border');
		logoText.classList.remove('hide-text');
	}
}
